/**
 * Formata telefone: (11) 99999-9999 ou (11) 9999-9999
 */
export function formatPhone(value) {
    const digits = value.replace(/\D/g, '').slice(0, 11);

    if (digits.length <= 2) return `(${digits}`;
    if (digits.length <= 6) return `(${digits.slice(0,2)}) ${digits.slice(2)}`;
    if (digits.length <= 10) return `(${digits.slice(0,2)}) ${digits.slice(2,6)}-${digits.slice(6)}`;
    return `(${digits.slice(0,2)}) ${digits.slice(2,7)}-${digits.slice(7)}`;
}

/**
 * Formata CNPJ: 00.000.000/0000-00
 */
export function formatCNPJ(value) {
    const digits = value.replace(/\D/g, '').slice(0, 14);

    if (digits.length <= 2)  return digits;
    if (digits.length <= 5)  return `${digits.slice(0,2)}.${digits.slice(2)}`;
    if (digits.length <= 8)  return `${digits.slice(0,2)}.${digits.slice(2,5)}.${digits.slice(5)}`;
    if (digits.length <= 12) return `${digits.slice(0,2)}.${digits.slice(2,5)}.${digits.slice(5,8)}/${digits.slice(8)}`;
    return `${digits.slice(0,2)}.${digits.slice(2,5)}.${digits.slice(5,8)}/${digits.slice(8,12)}-${digits.slice(12)}`;
}

/**
 * Formata CEP: 00000-000
 */
export function formatCEP(value) {
    const digits = value.replace(/\D/g, '').slice(0, 8);

    if (digits.length <= 5) return digits;
    return `${digits.slice(0,5)}-${digits.slice(5)}`;
}

/**
 * Formata CPF: 000.000.000-00
 */
export function formatCPF(value) {
    const digits = value.replace(/\D/g, '').slice(0, 11);

    if (digits.length <= 3)  return digits;
    if (digits.length <= 6)  return `${digits.slice(0,3)}.${digits.slice(3)}`;
    if (digits.length <= 9)  return `${digits.slice(0,3)}.${digits.slice(3,6)}.${digits.slice(6)}`;
    return `${digits.slice(0,3)}.${digits.slice(3,6)}.${digits.slice(6,9)}-${digits.slice(9)}`;
}

/**
 * Formata valor monetário: R$ 1.234,56
 */
export function formatCurrency(value) {
    const digits = String(value).replace(/\D/g, '');
    const number = (parseInt(digits, 10) / 100).toFixed(2);
    return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
    }).format(number);
}